import moment from 'moment';
import React, { useEffect, useState } from 'react';

import { Panel, Panels } from '~/src/dash/publicaUI';
import { isPublisherParent, isPublisherPublica } from '~/src/dash/utils/publishers';
import { useBaseConfig, useBaseStore } from '~/src/dash/views/base/contexts';
import { DashboardsContext } from '~/src/dash/views/dashboards/contexts';
import {
  EDashboardSection,
  IDashboardsConfig,
} from '~/src/dash/views/dashboards/DashboardHome/configs/dashboardsConfig';
import { DashboardLive } from '~/src/dash/views/dashboards/DashboardHome/sections/DashboardLive';
import { DashboardOverview } from '~/src/dash/views/dashboards/DashboardHome/sections/DashboardOverview';
import { DashboardParentOverview } from '~/src/dash/views/dashboards/DashboardHome/sections/DashboardParentOverview';
import { DashboardPublicaAnalytics } from '~/src/dash/views/dashboards/DashboardHome/sections/DashboardPublicaAnalytics';
import { TopBar } from '~/src/dash/views/topbar/TopBar';

interface IActiveSectionProps {
  activeSection: EDashboardSection;
  isPublica?: boolean;
  isParentPublisher?: boolean;
}

const ActiveSection = ({ activeSection, isParentPublisher, isPublica }: IActiveSectionProps) => {
  switch (activeSection) {
    case EDashboardSection.Live:
      return <DashboardLive />;
    case EDashboardSection.ParentOverview:
      if (isParentPublisher) return <DashboardParentOverview />;
    case EDashboardSection.PublicaAnalytics:
      if (isPublica) return <DashboardPublicaAnalytics />;
    default:
      return <DashboardOverview />;
  }
};

export const DashboardHome = () => {
  const { session } = useBaseStore();
  const { ID } = session.publisher;
  const isParentPublisher = isPublisherParent(ID);
  const isPublica = isPublisherPublica(ID);
  const { Dashboards } = useBaseConfig();
  const { defaultState, sections } = Dashboards.Main as IDashboardsConfig;

  const [activeSection, setActiveSection] = useState(
    isPublica ? EDashboardSection.PublicaAnalytics : defaultState.section,
  );

  // this formats the calendars to Mon-Sun and resets it back to Sun-Sat on unmount
  useEffect(() => {
    moment.updateLocale('en', {
      week: {
        dow: 1,
      },
    });
    moment.weekdays(true);
    return () => {
      moment.updateLocale('en', {
        week: {
          dow: 0,
        },
      });
      moment.weekdays(false);
    };
  }, []);

  useEffect(() => {
    defaultState.section = activeSection;
  }, [activeSection]);

  return (
    <DashboardsContext.Provider
      value={{ activeSection, setActiveSection, sections, isPublica, isParentPublisher }}
    >
      <Panels max vertical relative minWidthMain>
        <Panel largeHorizontalPadding smallVerticalPadding>
          <TopBar title='Dashboards' enableUINotices />
        </Panel>
        <Panel>
          <ActiveSection
            activeSection={activeSection}
            isPublica={isPublica}
            isParentPublisher={isParentPublisher}
          />
        </Panel>
      </Panels>
    </DashboardsContext.Provider>
  );
};
